import { createUseStyles } from 'react-jss';

const modalFooterUseStyles = createUseStyles((theme) => {
  const { bgColor, modal, spacing } = theme;
  return {
    wrenchModalFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      flexShrink: 0,
      padding: spacing[4],
      background: modal.footBgColor,
      borderBottomLeftRadius: modal.borderRadius,
      borderBottomRightRadius: modal.borderRadius,
      borderTop: `1px solid ${bgColor.accent}`,
      color: modal.footTypeColor,
    },

    wrenchModalActions: ({ align }) => ({
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'wrap',
      ...{
        right: { justifyContent: 'flex-end' },
        left: { justifyContent: 'flex-start' },
      }[align],
      '&:not([class^="wrenchButtonGroup"]) > button': {
        marginLeft: spacing[2],
      },
    }),
  };
});

export default modalFooterUseStyles;
